export default __webpack_public_path__ + "static/media/easy-jet.c7f00224.jpeg";